<template>
  <div class="enhancement">
    <FtaUpload
      v-model="values"
      ref="upload"
      v-bind="$attrs"
      :limit="limit"
      v-on="$listeners"
      @click.native="handleTrackTap"
    />
    <!-- <voucherPicking
      v-if="sources.length"
      :sources="sources"
      class="v-mt-10"
      :addSoucre="addSoucre"
      :getSources="getSources"
    /> -->
  </div>
</template>

<script>
import FtaUpload from '@meta-vue/cx-uploadfile'
import formMixin from '@meta-vue/vue-ele-form/lib/mixins/formMixin'
// import voucherPicking from '@/components/voucher-picking'
import sourceMixins from './source-mixins'
import { isEqual, debounce } from 'lodash'
// import { getRelativeByAbsolute } from '../voucher-picking/util'
export default {
  name: 'enhancement-y-upload',
  mixins: [formMixin, sourceMixins], // 必须引入mixin
  components: {
    FtaUpload
    // voucherPicking
  },

  data() {
    return {
      values: []
    }
  },

  computed: {
    limit() {
      return this.attrs?.['max-count']
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(val) {
        if (Array.isArray(val) && !isEqual(this.values, val)) {
          console.log('组件内数据：', val)
          this.values = [...val]
        }
      }
    },
    values: {
      immediate: true,
      handler(val) {
        if (Array.isArray(val) && !isEqual(this.value, val)) {
          console.log('组件内数据：', val)
          this.$emit('input', [...val])
        }
      }
    }
  },

  methods: {
    addSoucre({ url }) {
      if (!url) return
      if (this.limit && this.values?.length >= this.limit)
        return this.$message.error(`最多只允许上传${this.limit}个，添加失败`)
      // const relativeUrl = getRelativeByAbsolute(url)
      // const exist = this.values?.some?.(val => val?.includes?.(relativeUrl))
      // if (exist) return this.$message.error('该资源已存在，请勿重复上传')
      // this.values.push(url)
      // this.$message.success('添加成功')
      // this.$libTrack.tap?.('Quick_upload_vouchers', 'Voucher_upload', {
      //   pageName: 'zaixiangongzuotai',
      //   Session_ID: this?.$route?.query?.callId
      // })
    },
    handleTrackTap: debounce(function() {
      this.$libTrack.tap?.('Voucher_upload', 'Voucher_upload', {
        pageName: 'zaixiangongzuotai',
        Session_ID: this?.$route?.query?.callId
      })
    }, 500)
  }
}
</script>

<style lang="stylus" scoped></style>
